export const BOT_EMBED_STYLES = `
  .bb-embed-root {
    --bb-page-bg: #f8e71c;
    --bb-btn-color: #a1cbfa;
    --bb-footer-bg: #e6edf2;
    --bb-header-bg: #92f81e;
    --bb-icon-color: #4469d2;
    --bb-link-color: #265ea8;
    --bb-input-color: #040e16;
    --bb-bot-bg: #0b952b;
    --bb-bot-text: #000000;
    --bb-user-bg: #2fc1c1;
    --bb-user-text: #000000;
    --bb-input-bg: #ffffff;
    --bb-option-bg: #1d59a6;
    --bb-option-text: #ffffff;
    --bb-border-bot: #c1d3ee;
    --bb-border-user: #c1d3ee;
    --bb-button-text: #020619;
    --bb-body-font: Arial, sans-serif;
    --bb-title-scale: 1;
    --bb-widget-width: 420px;
    --bb-widget-height: 550px;
    box-sizing: border-box;
    color: #102033;
    font-family: var(--bb-body-font);
  }

  .bb-embed-root *,
  .bb-embed-root *::before,
  .bb-embed-root *::after {
    box-sizing: border-box;
    font-family: inherit;
  }

  .bb-embed-root button,
  .bb-embed-root input {
    font: inherit;
  }

  .bb-embed-root--embed {
    bottom: 18px;
    pointer-events: none;
    position: fixed;
    right: 18px;
    width: min(calc(100vw - 24px), var(--bb-widget-width));
    z-index: 2147483000;
  }

  .bb-embed-page {
    background:
      radial-gradient(circle at top left, rgba(255, 255, 255, 0.55), transparent 30%),
      linear-gradient(180deg, #f3f7fb 0%, #e8eef5 100%);
    min-height: 100vh;
    padding: 32px 18px 48px;
  }

  .bb-embed-page--preview {
    overflow: hidden;
  }

  .bb-embed-page--test {
    background:
      radial-gradient(circle at top right, rgba(146, 248, 30, 0.12), transparent 28%),
      linear-gradient(180deg, #eff4f9 0%, #e4ebf4 100%);
  }

  .bb-embed-preview-shell,
  .bb-embed-test-shell {
    margin: 0 auto;
    max-width: 1240px;
    width: 100%;
  }

  .bb-embed-preview-shell {
    display: grid;
    gap: 24px;
  }

  .bb-embed-hero {
    background: linear-gradient(135deg, #0b1625 0%, #1d3658 100%);
    border-radius: 28px;
    color: #f6fbff;
    overflow: hidden;
    padding: 28px;
    position: relative;
  }

  .bb-embed-hero::after {
    background: radial-gradient(circle, rgba(161, 203, 250, 0.4), transparent 60%);
    content: "";
    height: 360px;
    position: absolute;
    right: -80px;
    top: -140px;
    width: 360px;
  }

  .bb-embed-kicker {
    color: #9ac2ff;
    display: inline-flex;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  .bb-embed-hero h1,
  .bb-embed-test-copy h1 {
    font-size: calc(2.1rem * var(--bb-title-scale));
    line-height: 1.05;
    margin: 14px 0 14px;
  }

  .bb-embed-hero p,
  .bb-embed-test-copy p {
    color: rgba(246, 251, 255, 0.82);
    font-size: 1rem;
    line-height: 1.7;
    margin: 0;
    max-width: 620px;
  }

  .bb-embed-grid {
    display: grid;
    gap: 18px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .bb-embed-card {
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(15, 32, 52, 0.08);
    border-radius: 22px;
    box-shadow: 0 18px 45px rgba(17, 34, 56, 0.08);
    padding: 22px;
  }

  .bb-embed-card h3,
  .bb-embed-stat strong,
  .bb-embed-label {
    color: #12263d;
  }

  .bb-embed-card p,
  .bb-embed-stat span,
  .bb-embed-meta-line,
  .bb-embed-field-hint {
    color: #5b6c80;
    line-height: 1.6;
  }

  .bb-embed-preview-grid,
  .bb-embed-test-grid {
    align-items: start;
    display: grid;
    gap: 24px;
    grid-template-columns: minmax(0, 1fr) minmax(0, calc(var(--bb-widget-width) + 56px));
  }

  .bb-embed-test-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .bb-embed-surface {
    background: linear-gradient(180deg, #fbfcfe 0%, #eef3f8 100%);
    border: 1px solid rgba(17, 34, 56, 0.08);
    border-radius: 26px;
    min-height: 720px;
    overflow: hidden;
    position: relative;
  }

  .bb-embed-surface::before {
    background:
      linear-gradient(90deg, rgba(18, 38, 61, 0.05) 1px, transparent 1px),
      linear-gradient(rgba(18, 38, 61, 0.05) 1px, transparent 1px);
    background-size: 22px 22px;
    content: "";
    inset: 0;
    opacity: 0.32;
    position: absolute;
  }

  .bb-embed-surface-inner {
    display: grid;
    gap: 18px;
    padding: 30px;
    position: relative;
    z-index: 1;
  }

  .bb-embed-masthead {
    align-items: center;
    display: flex;
    gap: 14px;
    justify-content: space-between;
  }

  .bb-embed-brand {
    align-items: center;
    display: inline-flex;
    gap: 12px;
  }

  .bb-embed-brand-badge {
    align-items: center;
    background: #12263d;
    border-radius: 16px;
    color: #f4f8fc;
    display: inline-flex;
    font-size: 12px;
    font-weight: 700;
    height: 38px;
    justify-content: center;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    width: 38px;
  }

  .bb-embed-chip-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .bb-embed-chip {
    background: rgba(18, 38, 61, 0.06);
    border: 1px solid rgba(18, 38, 61, 0.08);
    border-radius: 999px;
    color: #37516c;
    font-size: 13px;
    font-weight: 600;
    padding: 10px 14px;
  }

  .bb-embed-panels {
    display: grid;
    gap: 18px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bb-embed-product-card {
    background: #ffffff;
    border: 1px solid rgba(18, 38, 61, 0.08);
    border-radius: 20px;
    min-height: 168px;
    padding: 20px;
  }

  .bb-embed-product-card strong {
    display: block;
    font-size: 1rem;
    margin-bottom: 8px;
  }

  .bb-embed-stat-grid {
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .bb-embed-stat {
    background: rgba(255, 255, 255, 0.92);
    border-radius: 18px;
    padding: 16px;
  }

  .bb-embed-stat strong {
    display: block;
    font-size: 1.15rem;
    margin-bottom: 6px;
  }

  .bb-embed-stage {
    align-items: flex-end;
    background:
      radial-gradient(circle at top right, rgba(161, 203, 250, 0.24), transparent 34%),
      linear-gradient(180deg, rgba(255, 255, 255, 0.88) 0%, rgba(233, 240, 247, 0.96) 100%);
    border: 1px solid rgba(17, 34, 56, 0.08);
    border-radius: 26px;
    display: flex;
    justify-content: flex-end;
    min-height: calc(var(--bb-widget-height) + 112px);
    overflow: hidden;
    padding: 24px;
    pointer-events: none;
    position: relative;
  }

  .bb-embed-stage-widget {
    margin-left: auto;
    max-width: 100%;
    pointer-events: none;
    position: relative;
    width: min(100%, var(--bb-widget-width));
  }

  .bb-embed-widget {
    display: flex;
    flex-direction: column;
    gap: 14px;
    pointer-events: none;
  }

  .bb-embed-widget--mobile {
    width: 100%;
  }

  .bb-embed-widget > * {
    pointer-events: auto;
  }

  .bb-embed-description {
    background: #f0f0f0;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 #d3d3d3;
    color: #000000;
    font-size: 14px;
    min-width: 240px;
    overflow: auto;
    padding: 24px 12px 12px;
    position: relative;
  }

  .bb-embed-description-body {
    display: flex;
    gap: 10px;
    position: relative;
    text-align: left;
  }

  .bb-embed-description-figure {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 999px;
    cursor: pointer;
    display: inline-flex;
    flex: 0 0 30px;
    height: 30px;
    justify-content: center;
    margin: 0;
    max-width: 30px;
    overflow: hidden;
    padding: 0;
    width: 30px;
  }

  .bb-embed-description-avatar {
    border-radius: 999px;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  .bb-embed-description p {
    flex: 1 1 auto;
    line-height: 1.6;
    margin: 0;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .bb-embed-description-close {
    align-items: center;
    background: #cccccc;
    border: 0;
    border-radius: 999px;
    color: #000000;
    cursor: pointer;
    display: inline-flex;
    font-size: 12px;
    font-weight: 500;
    height: 22px;
    justify-content: center;
    padding: 0;
    position: absolute;
    right: 5px;
    top: 5px;
    width: 22px;
  }

  .bb-embed-description-close:hover {
    background: #000000;
    color: #ffffff;
  }

  .bb-embed-window {
    background: var(--bb-page-bg);
    border: 1px solid rgba(18, 38, 61, 0.1);
    border-radius: 28px;
    box-shadow: 0 28px 80px rgba(17, 34, 56, 0.18);
    display: flex;
    flex-direction: column;
    height: var(--bb-widget-height);
    max-height: min(78vh, var(--bb-widget-height));
    overflow: hidden;
    transform-origin: bottom right;
  }

  .bb-embed-window--closed {
    display: none;
  }

  .bb-embed-window--mobile-modal {
    border-radius: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
    height: 100dvh !important;
    left: 0 !important;
    max-height: 100vh !important;
    max-height: 100dvh !important;
    position: fixed !important;
    right: 0 !important;
    top: 0 !important;
    width: 100vw !important;
  }

  .bb-embed-window--mobile-modal .bb-embed-header {
    padding:
      calc(14px + env(safe-area-inset-top, 0px))
      14px
      14px;
  }

  .bb-embed-window--mobile-modal .bb-embed-body {
    gap: 14px;
    min-height: 0;
    padding: 14px;
  }

  .bb-embed-window--mobile-modal .bb-embed-transcript {
    padding-right: 2px;
  }

  .bb-embed-window--mobile-modal .bb-embed-bubble {
    max-width: 92%;
  }

  .bb-embed-window--mobile-modal .bb-embed-quick-actions {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 2px;
  }

  .bb-embed-window--mobile-modal .bb-embed-quick-action {
    flex: 0 0 auto;
  }

  .bb-embed-window--mobile-modal .bb-embed-footer {
    padding:
      12px
      14px
      calc(12px + env(safe-area-inset-bottom, 0px));
  }

  .bb-embed-window--mobile-modal .bb-embed-emoji-picker {
    left: 0;
    max-width: min(320px, calc(100vw - 28px));
  }

  .bb-embed-window--mobile-modal .bb-embed-emoji-picker em-emoji-picker,
  .bb-embed-window--mobile-modal .bb-embed-emoji-loading {
    max-width: min(320px, calc(100vw - 28px));
  }

  .bb-embed-window--mobile-modal .bb-embed-emoji-loading {
    width: min(320px, calc(100vw - 28px));
  }

  .bb-embed-window--mobile-portrait .bb-embed-input-row {
    flex-wrap: wrap;
  }

  .bb-embed-window--mobile-portrait .bb-embed-send {
    width: 100%;
  }

  .bb-embed-window--mobile-landscape .bb-embed-header {
    padding:
      calc(10px + env(safe-area-inset-top, 0px))
      14px
      10px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-header-main {
    gap: 10px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-avatar {
    border-radius: 14px;
    height: 42px;
    width: 42px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-title {
    font-size: calc(1rem * var(--bb-title-scale));
  }

  .bb-embed-window--mobile-landscape .bb-embed-subtitle {
    display: none;
  }

  .bb-embed-window--mobile-landscape .bb-embed-body {
    gap: 10px;
    min-height: 0;
    padding: 12px 14px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-transcript {
    gap: 10px;
    min-height: 0;
  }

  .bb-embed-window--mobile-landscape .bb-embed-bubble {
    border-radius: 16px;
    max-width: 88%;
    padding: 10px 12px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-message-actions,
  .bb-embed-window--mobile-landscape .bb-embed-message-links,
  .bb-embed-window--mobile-landscape .bb-embed-quick-actions {
    gap: 6px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-quick-actions {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 2px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-quick-action,
  .bb-embed-window--mobile-landscape .bb-embed-message-action,
  .bb-embed-window--mobile-landscape .bb-embed-message-link {
    flex: 0 0 auto;
    min-height: 28px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-input {
    padding: 8px 10px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-input-row {
    flex-wrap: nowrap;
    gap: 8px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-emoji-trigger {
    flex: 0 0 40px;
    height: 40px;
    width: 40px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-input-row textarea {
    max-height: 96px;
    min-height: 40px;
    padding: 10px 12px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-tel-input .MuiInputBase-root {
    min-height: 40px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-send {
    min-width: 72px;
    padding: 11px 14px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-footer {
    align-items: flex-start;
    gap: 8px;
    justify-content: space-between;
    padding:
      10px
      14px
      calc(10px + env(safe-area-inset-bottom, 0px));
  }

  .bb-embed-window--mobile-landscape .bb-embed-pills {
    gap: 6px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-pill {
    font-size: 11px;
    padding: 6px 8px;
  }

  .bb-embed-window--mobile-landscape .bb-embed-footer a {
    font-size: 11px;
  }

  .bb-embed-header {
    align-items: center;
    background:
      linear-gradient(135deg, rgba(255, 255, 255, 0.35), transparent 50%),
      var(--bb-header-bg);
    display: flex;
    gap: 14px;
    justify-content: space-between;
    padding: 18px;
  }

  .bb-embed-header-main {
    align-items: center;
    display: flex;
    gap: 14px;
    min-width: 0;
  }

  .bb-embed-avatar {
    border: 2px solid rgba(255, 255, 255, 0.75);
    border-radius: 18px;
    flex-shrink: 0;
    height: 48px;
    object-fit: cover;
    width: 48px;
  }

  .bb-embed-title {
    font-size: calc(1.1rem * var(--bb-title-scale));
    font-weight: 800;
    line-height: 1.2;
    margin: 0;
  }

  .bb-embed-title-row {
    align-items: center;
    display: flex;
    gap: 8px;
    min-width: 0;
  }

  .bb-embed-clear-button {
    align-items: center;
    background: rgba(255, 255, 255, 0.55);
    border: 0;
    border-radius: 999px;
    color: #102033;
    cursor: pointer;
    display: inline-flex;
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 700;
    gap: 4px;
    line-height: 1;
    padding: 6px 10px;
    transition: transform 0.18s ease, background 0.18s ease;
  }

  .bb-embed-clear-button:hover {
    background: rgba(255, 255, 255, 0.8);
    transform: translateY(-1px);
  }

  .bb-embed-subtitle {
    color: rgba(16, 32, 51, 0.76);
    font-size: 13px;
    margin: 4px 0 0;
  }

  .bb-embed-icon-button {
    align-items: center;
    background: rgba(255, 255, 255, 0.55);
    border: 0;
    border-radius: 14px;
    color: #102033;
    cursor: pointer;
    display: inline-flex;
    height: 38px;
    justify-content: center;
    transition: transform 0.18s ease, background 0.18s ease;
    width: 38px;
  }

  .bb-embed-icon-button:hover {
    background: rgba(255, 255, 255, 0.8);
    transform: translateY(-1px);
  }

  .bb-embed-body {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
    padding: 18px;
  }

  .bb-embed-banner {
    align-items: center;
    background: rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(18, 38, 61, 0.08);
    border-radius: 18px;
    display: flex;
    gap: 12px;
    padding: 12px 14px;
  }

  .bb-embed-banner-icon {
    align-items: center;
    background: rgba(68, 105, 210, 0.12);
    border-radius: 12px;
    color: var(--bb-icon-color);
    display: inline-flex;
    flex-shrink: 0;
    height: 36px;
    justify-content: center;
    width: 36px;
  }

  .bb-embed-banner strong {
    display: block;
    font-size: 14px;
    margin-bottom: 2px;
  }

  .bb-embed-banner span {
    color: #506173;
    display: block;
    font-size: 12px;
  }

  .bb-embed-widget-note,
  .bb-embed-inline-note {
    border-radius: 16px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.5;
    padding: 10px 12px;
  }

  .bb-embed-status--loading {
    background: rgba(68, 105, 210, 0.1);
    color: #234a96;
  }

  .bb-embed-status--fallback {
    background: rgba(187, 84, 28, 0.12);
    color: #8f4a16;
  }

  .bb-embed-status--live {
    background: rgba(11, 149, 43, 0.12);
    color: #0c6a23;
  }

  .bb-embed-transcript {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 12px;
    overflow: auto;
    padding-right: 4px;
  }

  .bb-embed-message {
    display: flex;
  }

  .bb-embed-message--assistant {
    justify-content: flex-start;
  }

  .bb-embed-message--user {
    justify-content: flex-end;
  }

  .bb-embed-bubble {
    border-radius: 18px;
    max-width: 85%;
    padding: 12px 14px;
  }

  .bb-embed-bubble--assistant {
    background: var(--bb-bot-bg);
    border: 1px solid var(--bb-border-bot);
    border-bottom-left-radius: 8px;
    color: var(--bb-bot-text);
  }

  .bb-embed-bubble--user {
    background: var(--bb-user-bg);
    border: 1px solid var(--bb-border-user);
    border-bottom-right-radius: 8px;
    color: var(--bb-user-text);
  }

  .bb-embed-bubble p {
    line-height: 1.55;
    margin: 0;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }

  .bb-embed-bubble-html {
    line-height: 1.55;
    margin: 0;
    overflow-wrap: anywhere;
  }

  .bb-embed-bubble-html a {
    color: var(--bb-link-color);
    text-decoration: underline;
  }

  .bb-embed-bubble-html code {
    background: rgba(15, 23, 42, 0.08);
    border-radius: 6px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 0.92em;
    padding: 0.1em 0.35em;
  }

  .bb-embed-bubble-html pre {
    background: rgba(15, 23, 42, 0.08);
    border-radius: 12px;
    margin: 10px 0;
    overflow-x: auto;
    padding: 12px;
  }

  .bb-embed-bubble-html pre code {
    background: transparent;
    padding: 0;
  }

  .bb-embed-bubble-html ul,
  .bb-embed-bubble-html ol {
    margin: 10px 0;
    padding-left: 20px;
  }

  .bb-embed-bubble-html li + li {
    margin-top: 4px;
  }

  .bb-embed-bubble-html blockquote {
    border-left: 3px solid rgba(38, 94, 168, 0.35);
    margin: 10px 0;
    padding: 2px 0 2px 12px;
  }

  .bb-embed-bubble-html h1,
  .bb-embed-bubble-html h2,
  .bb-embed-bubble-html h3,
  .bb-embed-bubble-html h4,
  .bb-embed-bubble-html h5,
  .bb-embed-bubble-html h6 {
    line-height: 1.25;
    margin: 12px 0 8px;
  }

  .bb-embed-bubble-html > :first-child {
    margin-top: 0;
  }

  .bb-embed-bubble-html > :last-child {
    margin-bottom: 0;
  }

  .bb-embed-message-time {
    font-size: 11px;
    line-height: 1.3;
    margin-top: 8px;
    opacity: 0.72;
  }

  .bb-embed-message-time--assistant {
    text-align: left;
  }

  .bb-embed-message-time--user {
    text-align: right;
  }

  .bb-embed-attachment {
    margin-bottom: 10px;
  }

  .bb-embed-message-actions,
  .bb-embed-message-links {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
  }

  .bb-embed-message-action,
  .bb-embed-message-link {
    align-items: center;
    background: color-mix(in srgb, var(--bb-option-bg) 88%, white 12%);
    border: 1px solid color-mix(in srgb, var(--bb-option-bg) 92%, white 8%);
    border-radius: 999px;
    color: var(--bb-option-text);
    cursor: pointer;
    display: inline-flex;
    font-size: 12px;
    font-weight: 700;
    justify-content: center;
    min-height: 32px;
    padding: 0 12px;
    text-align: center;
    text-decoration: none;
    transition:
      background-color 0.18s ease,
      border-color 0.18s ease,
      transform 0.18s ease;
  }

  .bb-embed-message-action:hover,
  .bb-embed-message-link:hover {
    background: color-mix(in srgb, var(--bb-option-bg) 94%, white 6%);
    border-color: color-mix(in srgb, var(--bb-option-bg) 98%, white 2%);
    transform: translateY(-1px);
  }

  .bb-embed-message-action--selected {
    background: color-mix(in srgb, var(--bb-option-bg) 100%, black 8%);
    border-color: color-mix(in srgb, var(--bb-option-bg) 85%, black 15%);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
  }

  .bb-embed-message-action:disabled {
    cursor: not-allowed;
    opacity: 0.52;
    transform: none;
  }

  .bb-embed-typing {
    align-items: center;
    display: inline-flex;
    gap: 6px;
  }

  .bb-embed-dot {
    animation: bb-embed-pulse 1.15s infinite ease-in-out;
    background: currentColor;
    border-radius: 999px;
    display: inline-flex;
    height: 7px;
    opacity: 0.4;
    width: 7px;
  }

  .bb-embed-dot:nth-child(2) {
    animation-delay: 0.16s;
  }

  .bb-embed-dot:nth-child(3) {
    animation-delay: 0.32s;
  }

  .bb-embed-quick-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .bb-embed-quick-action {
    align-items: center;
    background: color-mix(in srgb, var(--bb-option-bg) 75%, #4F8ED2);
    border: 1px solid color-mix(in srgb, var(--bb-option-bg) 85%, #4F8ED2);
    border-radius: 4px;
    color: var(--bb-option-text);
    cursor: pointer;
    display: inline-flex;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.01em;
    line-height: 1.2;
    min-height: 30px;
    padding: 4px;
    transition:
      background-color 0.18s ease,
      border-color 0.18s ease,
      box-shadow 0.18s ease,
      transform 0.18s ease;
  }

  .bb-embed-quick-action:hover {
    background: color-mix(in srgb, var(--bb-option-bg) 90%, #4F8ED2);
    border-color: color-mix(in srgb, var(--bb-option-bg) 95%, #4F8ED2);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
    transform: translateY(-1px);
  }

  .bb-embed-input {
    background: rgba(255, 255, 255, 0.58);
    border: 1px solid rgba(18, 38, 61, 0.08);
    border-radius: 22px;
    padding: 12px;
  }

  .bb-embed-composer-attachment {
    margin-bottom: 10px;
  }

  .bb-embed-input-row {
    align-items: flex-end;
    display: flex;
    gap: 10px;
    position: relative;
  }

  .bb-embed-file-input {
    display: none;
  }

  .bb-embed-emoji-wrap {
    position: relative;
  }

  .bb-embed-emoji-trigger {
    align-items: center;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(18, 38, 61, 0.1);
    border-radius: 14px;
    color: #526375;
    cursor: pointer;
    display: inline-flex;
    height: 48px;
    justify-content: center;
    padding: 0;
    transition:
      border-color 0.18s ease,
      box-shadow 0.18s ease,
      color 0.18s ease,
      transform 0.18s ease;
    width: 48px;
  }

  .bb-embed-emoji-trigger:hover {
    border-color: rgba(18, 38, 61, 0.18);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
    color: #2e3e50;
    transform: translateY(-1px);
  }

  .bb-embed-emoji-picker {
    bottom: calc(100% + 10px);
    left: 0;
    position: absolute;
    z-index: 20;
  }

  .bb-embed-emoji-picker em-emoji-picker {
    border-radius: 18px;
    box-shadow: 0 18px 42px rgba(15, 23, 42, 0.16);
  }

  .bb-embed-emoji-loading {
    background: #ffffff;
    border: 1px solid rgba(18, 38, 61, 0.08);
    border-radius: 18px;
    height: 320px;
    width: 320px;
  }

  .bb-embed-input-row textarea {
    background: var(--bb-input-bg);
    border: 1px solid rgba(18, 38, 61, 0.08);
    border-radius: 16px;
    color: var(--bb-input-color);
    flex: 1;
    min-width: 0;
    outline: none;
    max-height: 140px;
    min-height: 48px;
    overflow-y: auto;
    padding: 13px 16px;
    resize: none;
    white-space: pre-wrap;
  }

  .bb-embed-tel-input {
    flex: 1;
    min-width: 0;
  }

  .bb-embed-tel-input .MuiInputBase-root {
    background: var(--bb-input-bg);
    border-radius: 16px;
    min-height: 48px;
  }

  .bb-embed-tel-input .MuiOutlinedInput-notchedOutline {
    border-color: rgba(18, 38, 61, 0.08);
  }

  .bb-embed-tel-input .MuiInputBase-input,
  .bb-embed-tel-input .MuiTypography-root,
  .bb-embed-tel-input .MuiIconButton-root {
    color: var(--bb-input-color);
  }

  .bb-embed-send {
    align-items: center;
    background: var(--bb-btn-color);
    border: 0;
    border-radius: 16px;
    color: var(--bb-button-text);
    cursor: pointer;
    display: inline-flex;
    flex-shrink: 0;
    font-weight: 700;
    gap: 8px;
    justify-content: center;
    padding: 14px 18px;
  }

  .bb-embed-send:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }

  .bb-embed-footer {
    align-items: center;
    background: var(--bb-footer-bg);
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
    padding: 14px 18px;
  }

  .bb-embed-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .bb-embed-pill {
    background: rgba(255, 255, 255, 0.68);
    border-radius: 999px;
    color: #41566d;
    font-size: 12px;
    font-weight: 700;
    padding: 8px 10px;
  }

  .bb-embed-footer a {
    color: var(--bb-link-color);
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
  }

  .bb-embed-legal-modal {
    align-items: center;
    background: rgba(15, 23, 42, 0.38);
    display: flex;
    inset: 0;
    justify-content: center;
    padding: 20px;
    position: fixed;
    z-index: 2147483600;
  }

  .bb-embed-legal-modal-card {
    background: #ffffff;
    border-radius: 18px;
    box-shadow: 0 28px 80px rgba(17, 34, 56, 0.24);
    display: flex;
    flex-direction: column;
    height: min(78vh, 720px);
    max-width: 860px;
    overflow: hidden;
    width: min(92vw, 860px);
  }

  .bb-embed-confirm-modal-card {
    background: #ffffff;
    border-radius: 18px;
    box-shadow: 0 28px 80px rgba(17, 34, 56, 0.24);
    max-width: 420px;
    overflow: hidden;
    width: min(92vw, 420px);
  }

  .bb-embed-legal-modal-header {
    align-items: center;
    border-bottom: 1px solid rgba(18, 38, 61, 0.08);
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 14px 16px;
  }

  .bb-embed-legal-modal-header strong {
    color: #102033;
    font-size: 14px;
  }

  .bb-embed-legal-modal-close {
    align-items: center;
    background: rgba(18, 38, 61, 0.08);
    border: 0;
    border-radius: 999px;
    color: #23374d;
    cursor: pointer;
    display: inline-flex;
    height: 30px;
    justify-content: center;
    width: 30px;
  }

  .bb-embed-legal-modal-frame {
    border: 0;
    flex: 1;
    min-height: 0;
    width: 100%;
  }

  .bb-embed-confirm-modal-body {
    color: #425466;
    font-size: 14px;
    line-height: 1.6;
    padding: 18px 16px 0;
  }

  .bb-embed-confirm-modal-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding: 18px 16px 16px;
  }

  .bb-embed-confirm-button {
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    min-width: 72px;
    padding: 10px 16px;
    transition: transform 0.18s ease, opacity 0.18s ease;
  }

  .bb-embed-confirm-button:hover {
    transform: translateY(-1px);
  }

  .bb-embed-confirm-button--secondary {
    background: rgba(18, 38, 61, 0.08);
    color: #23374d;
  }

  .bb-embed-confirm-button--danger {
    background: #d14343;
    color: #ffffff;
  }

  .bb-embed-launcher {
    align-items: center;
    align-self: flex-end;
    
    border: 0;
    border-radius: 22px;
    color: var(--bb-button-text);
    cursor: pointer;
    display: inline-flex;
    gap: 12px;
    min-height: 64px;
    padding: 12px 16px;
  }

  .bb-embed-launcher img {
    border-radius: 16px;
    height: 38px;
    object-fit: cover;
    width: 38px;
  }

  .bb-embed-launcher-placeholder {
    animation: bb-embed-launcher-pulse 1.2s ease-in-out infinite;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.92),
      rgba(255, 255, 255, 0.58)
    );
    border-radius: 16px;
    box-shadow: inset 0 0 0 1px rgba(16, 32, 51, 0.08);
    display: inline-flex;
    height: 38px;
    position: relative;
    width: 38px;
  }

  .bb-embed-launcher-placeholder::after {
    border: 2px solid rgba(16, 32, 51, 0.18);
    border-right-color: var(--bb-icon-color);
    border-radius: 999px;
    content: "";
    inset: 9px;
    position: absolute;
  }

  .bb-embed-launcher--compact {
    border-radius: 999px;
    justify-content: center;
    min-height: 60px;
    min-width: 60px;
    padding: 11px;
  }

  .bb-embed-launcher-copy {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  .bb-embed-launcher-copy strong {
    font-size: 14px;
    line-height: 1.2;
  }

  .bb-embed-launcher-copy span {
    font-size: 12px;
    opacity: 0.7;
  }

  @keyframes bb-embed-launcher-pulse {
    0%,
    100% {
      transform: scale(1);
    }

    50% {
      transform: scale(0.96);
    }
  }

  .bb-embed-test-shell {
    display: grid;
    gap: 24px;
  }

  .bb-embed-test-copy {
    background: linear-gradient(135deg, #12263d 0%, #224e7a 100%);
    border-radius: 28px;
    color: #f6fbff;
    padding: 28px;
  }

  .bb-embed-test-controls {
    align-content: start;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(18, 38, 61, 0.08);
    border-radius: 24px;
    display: grid;
    gap: 18px;
    min-width: 0;
    padding: 22px;
  }

  .bb-embed-stage--test {
    justify-content: center;
    min-height: calc(var(--bb-widget-height) + 88px);
  }

  .bb-embed-stage--test .bb-embed-stage-widget {
    margin: 0 auto;
  }

  .bb-embed-field {
    display: grid;
    gap: 10px;
  }

  .bb-embed-field label {
    color: #12263d;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
  }

  .bb-embed-field-row {
    display: grid;
    gap: 10px;
    grid-template-columns: minmax(0, 1fr) auto auto;
  }

  .bb-embed-field input {
    background: #f7fafd;
    border: 1px solid rgba(18, 38, 61, 0.1);
    border-radius: 16px;
    min-width: 0;
    outline: none;
    padding: 14px 16px;
  }

  .bb-embed-field button {
    border: 0;
    border-radius: 16px;
    cursor: pointer;
    font-weight: 700;
    padding: 14px 16px;
  }

  .bb-embed-primary-btn {
    background: #12263d;
    color: #ffffff;
  }

  .bb-embed-secondary-btn {
    background: #e7edf5;
    color: #223449;
  }

  .bb-embed-swatch-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .bb-embed-swatch {
    align-items: center;
    display: inline-flex;
    gap: 10px;
    min-width: 120px;
  }

  .bb-embed-swatch i {
    border: 1px solid rgba(18, 38, 61, 0.1);
    border-radius: 999px;
    display: inline-flex;
    flex-shrink: 0;
    height: 14px;
    width: 14px;
  }

  .bb-embed-note {
    color: #57697d;
    font-size: 13px;
    line-height: 1.65;
  }

  .bb-embed-scrollbar::-webkit-scrollbar,
  .bb-embed-transcript::-webkit-scrollbar {
    width: 8px;
  }

  .bb-embed-scrollbar::-webkit-scrollbar-thumb,
  .bb-embed-transcript::-webkit-scrollbar-thumb {
    background: rgba(18, 38, 61, 0.18);
    border-radius: 999px;
  }

  @keyframes bb-embed-pulse {
    0%, 80%, 100% {
      opacity: 0.35;
      transform: translateY(0);
    }
    40% {
      opacity: 1;
      transform: translateY(-2px);
    }
  }

  @media (max-width: 1100px) {
    .bb-embed-preview-grid,
    .bb-embed-test-grid {
      grid-template-columns: 1fr;
    }

    .bb-embed-stage {
      min-height: calc(var(--bb-widget-height) + 96px);
    }

    .bb-embed-stage-widget {
      width: min(100%, var(--bb-widget-width));
    }
  }

  @media (max-width: 820px) {
    .bb-embed-grid,
    .bb-embed-panels,
    .bb-embed-stat-grid {
      grid-template-columns: 1fr;
    }

    .bb-embed-surface {
      min-height: 820px;
    }
  }

  @media (max-width: 680px) {
    .bb-embed-root--embed {
      bottom: 12px;
      left: 12px;
      right: 12px;
      width: auto;
    }

    .bb-embed-window {
      height: min(76vh, var(--bb-widget-height));
      max-height: min(76vh, var(--bb-widget-height));
    }

    .bb-embed-field-row {
      grid-template-columns: 1fr;
    }

    .bb-embed-stage {
      min-height: calc(var(--bb-widget-height) + 72px);
      padding: 18px 12px;
    }

    .bb-embed-stage-widget {
      width: 100%;
    }

    .bb-embed-page {
      padding: 18px 12px 30px;
    }

    .bb-embed-hero,
    .bb-embed-test-copy,
    .bb-embed-test-controls,
    .bb-embed-card {
      border-radius: 20px;
      padding: 18px;
    }
  }


  

  @media screen and (max-width: 767px) {
    .bb-embed-description {
      max-width: calc(100vw - 24px);
      min-width: 0;
    }

    .bb-embed-header {
      padding: 10px;
    }

    .bb-embed-title-row {
      align-items: flex-start;
      flex-direction: column;
      gap: 6px;
    }

    .bb-embed-body {
      padding: 10px;
    }

    .bb-embed-input {
      padding: 8px;
    }

    .bb-embed-input-row {
      flex-wrap: wrap;
      gap: 6px;
    }

    .bb-embed-emoji-trigger {
      height: 40px;
      width: 40px;
    }

    .bb-embed-input-row textarea {
      padding: 8px 11px;
      min-height: 40px;
      font-size: 14px;
    }

    .bb-embed-tel-input {
      width: 100%;
    }

    .bb-embed-send {
      padding: 8.8px 12px;
    }

    .bb-embed-footer {
      padding: 10px 12px;
    }

    .bb-embed-confirm-modal-actions {
      flex-direction: column-reverse;
    }

    .bb-embed-confirm-button {
      width: 100%;
    }
  }

`;
